import React, { useState, useEffect } from 'react';
import './App.css';
import TopBanner from './components/TopBanner';
import NavigationBar from './components/NavigationBar';
import HeroSection from './components/HeroSection';
import SocialProof from './components/SocialProof';
import HeroWithTabs from './components/HeroWithTabs';
import Experts from './components/Experts';
import Reviews from './components/Reviews';
import ExploreLibrary from './components/ExploreLibrary';
import MeetAstrologer from './components/MeetAstrologer';
import FAQ from './components/FAQ';
import GetApp from './components/GetApp';
import Footer from './components/Footer';
import AstrologerApplication from './components/AstrologerApplication';
// import CreateKundali from './components/CreateKundali';

function App() {
  const [showApplication, setShowApplication] = useState(false);
  // const [showCreateKundali, setShowCreateKundali] = useState(false);

  useEffect(() => {
    // Check if URL hash is #for-astrologers or #create-kundali
    const checkHash = () => {
      const hash = window.location.hash;
      if (hash === '#for-astrologers') {
        setShowApplication(true);
        // setShowCreateKundali(false);
      } else if (hash === '#create-kundali') {
        // setShowCreateKundali(true);
        setShowApplication(false);
      } else {
        setShowApplication(false);
        // setShowCreateKundali(false);
        // Check if we have a stored target hash from navigation
        const targetHash = sessionStorage.getItem('targetHash');
        if (targetHash) {
          sessionStorage.removeItem('targetHash');
          setTimeout(() => {
            window.location.hash = targetHash;
          }, 100);
        }
      }
    };

    checkHash();

    // Listen for hash changes
    const handleHashChange = () => {
      checkHash();
    };

    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  if (showApplication) {
    return (
      <div className="App">
        <NavigationBar />
        <AstrologerApplication />
        <Footer />
      </div>
    );
  }

  // if (showCreateKundali) {
  //   return (
  //     <div className="App">
  //       <NavigationBar />
  //       <CreateKundali />
  //       <Footer />
  //     </div>
  //   );
  // }

  return (
    <div className="App">
      <NavigationBar />
      <main>
        <HeroSection />
        <TopBanner />
        <SocialProof />
        <HeroWithTabs />
        <Experts />
        <Reviews />
        <TopBanner />
        <ExploreLibrary />
        <MeetAstrologer />
        <FAQ />
        <GetApp />
      </main>
      <Footer />
    </div>
  );
}

export default App;
